'use client';

import Image from "next/image";
import { useMemo } from "react";

// Ctx
import useListListingCtx from "@src/context/list-listing-ctx";

// Assets
import XIcon from '@public/png/x-1.png';

const ButtonClose = ({ label, isActive, ...props }) => {
  return (
    <button {...props} className={`${isActive ? "bg-white border border-solid border-[#F6F6F6]" : "bg-[#F6F6F6]"} h-[40px] flex items-center px-2 py-[5px] rounded`}>
      <span className={`text-[14px] ${isActive ? "font-satoshi-bold" : ""}`}>{label}</span>
      {isActive && <div className='ml-2 p-2 flex justify-center items-center bg-[#FFEAE9] rounded-2xl'>
        <Image
          width={12}
          height={12}
          src={XIcon}
          alt='Close'
          className='w-[12px] aspect-square object-contain'
        />
      </div>}
    </button>

  )
}

const ListListingSelectedCategory = () => {
  const { params, setParams, listPropertyCategories } = useListListingCtx()

  const GroupCategory = useMemo(() => {
    if(!listPropertyCategories?.length) return []

    return listPropertyCategories.filter(p => (p?.name ?? "").toLowerCase() === "rumah" || (p?.name ?? "").toLowerCase() === "apartment")
  }, [listPropertyCategories])

  const handleSelectCategory = (d, isActive) => {
    if(isActive){
      setParams({ ...params, property_category_id: null })
    } else {
      setParams({ ...params, property_category_id: d.id })
    }
  }

  return (
    <div className="flex items-center gap-2">
      {!!GroupCategory?.length && GroupCategory.map((d, i) => {
        const isActive = +params.property_category_id === d.id;
        return (
          <ButtonClose 
            key={`list-default-category-${i}`} 
            isActive={isActive} 
            label={d.name} 
            onClick={() => handleSelectCategory(d, isActive)}
          />
        )
      })}
    </div>
  )
}

export default ListListingSelectedCategory
